/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './basic-page-header.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface BasicPageHeaderProps {
    /**
     * Child elements
     */
    children?: ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledBasicPageHeader = styled('header').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const BasicPageHeader: FunctionComponent<BasicPageHeaderProps> = ({
    children,
    ...otherProps
}: BasicPageHeaderProps) => {
    return (
        <StyledBasicPageHeader {...otherProps}>
            {children}
        </StyledBasicPageHeader>
    );
};
